PegasusTemplate.AutoSaveView = Em.View.extend({
  classNames: ['vr-last-saved'],
  classNameBindings: ['controller.isCurrent:vr-up-to-date:vr-outdated'],
  templateName: 'auto_save',
  click: function(){
    this.get('controller').send('saveSnapshot');
  }
});
